const user = (state) => state.user;
const notExistsEmail = (state) => state.notExistsEmail;
const isUserMetadataLoading = (state) => state.isUserMetadataLoading;
const lastLoggedIn = (state) => state.lastLoggedIn;

export const getters = {
  user,
  notExistsEmail,
  isUserMetadataLoading,
  lastLoggedIn,
};
